<template>
  <div class="container tabStyle">
    <div style="margin: 0.3rem 0.3rem 0;">
      <header-body advertisingPosition="4" source="task"></header-body>
    </div>
    <div v-if="show">
    <van-tabs v-model="active" @click="onClick" sticky background="#F6F6F6" title-active-color="#333" title-inactive-color="#888">
      <van-tab v-for="(item,index) in tab" :key="index">
        <template #title>{{item.name}}&nbsp;<van-icon name="question-o" style="vertical-align: sub;" @click="question" v-if="index == '0'"/></template>
        <div class="list" v-if="task.length && task.length >0">
              <div class="posts-list" v-for="(item,index) in task" :key="index" @click="view(item)">
                <span :class="(item.status=='1'||item.status=='8'||item.status=='9')?'color1':(item.status=='2'||item.status == '3')?'color23':(item.status=='4')?'color4':(item.status=='5')?'color5':(item.status=='6')?'color6':'color7'">
                  {{(item.status == '1'||item.status=='8'||item.status=='9')?'即将开始':(item.status == '2'||item.status == '3')?'进行中':(item.status == '4')?'积分发放中':(item.status == '5')?'失败':(item.status == '6')?'已完成':'已过期'}}
                  </span>
                <h1>{{item.taskName}}</h1>
                <p>
                  活动时间<i>&nbsp;&nbsp;{{item.startTime}} ~ {{item.endTime}}</i>
                </p>
                <h2>{{item.taskType == '3'||item.taskType == '4'?'最高':''}}奖励&nbsp;&nbsp;{{numStr(item.rewardAmount)}}积分</h2>
                <a class="button" v-if="(item.taskType == '3'||item.taskType == '4')&&(item.status == '9'||item.status == '2'||item.status == '3')" @click.stop="get(item)">{{item.status == '3'?'做任务':'领取任务'}}</a>
              </div>
            </div>
            <div v-if="task.length=='0'" class="no-data">
              <img src="../img/none.png" alt="" style="width:2.7rem;">
              <p style="color:#999;margin-top:0.3rem;">当前还没有任务哦~</p>
            </div>
      </van-tab>
    </van-tabs>
    </div>
  </div>
</template>

<script>
import headerBody from "../../common/header/header";
export default {
  name: "list",
  components: {
    headerBody,
  },
  inject:['reload'],
  data() {
    return {
      tmp:[],
      task: [],
      page: {
        memberId: "0",
        page: "",
        limit: "",
      },
      show:false,
      active:"0",
      tab:[{name:'进行中'},{name:'可领取'},{name:'已结束'}],
      canSubmit: true,
      channelType:""
    };
  },
  computed: {},
  filters: {},
  created() {
    this.list();
    this.channelType = JSON.parse(sessionStorage.getItem("user")).channelType;
    if(this.channelType == 'app') UnionDrugHealthy.hiddenShareIcon()
  },
  methods: {
    view(item){
      // 任务详情
      // location.href = `/distribution/taskInfo?id=${item.id}&taskType=${item.taskType}`
      this.$router.push('/taskInfo?id='+item.id+'&taskType='+item.taskType)
    },
    get(item){
      if(item.status == '3'){
      // 做任务
      this.$router.push('/taskInfo?id='+item.id+'&taskType='+item.taskType)
      }else{
      // 领取任务
      if (!this.canSubmit) return;
      this.canSubmit = false;
      let post = {
        taskId: item.id,
        memberId: JSON.parse(sessionStorage.getItem("user")).memberId,
      };
      this.$api.taskReceive(post).then((res) => {
        if(res.errno == '0'){
          this.$toast.success('任务领取成功');
          setTimeout(() => {
            this.reload()
             this.list()
          }, 2000);
        }
      });
      }
    },
    list() {
        this.$api.taskList({memberId:JSON.parse(sessionStorage.getItem("user")).memberId}).then(res => {
          if(res.errno == '0'){
            this.tmp = res.data.body;
            this.canSubmit = true
            this.show = true
            this.active = '0'
            this.task = this.tmp.filter(item => item.status==1||item.status==3||item.status==4||item.status==8 )
            this.$nextTick(() => {
            var demo = document.getElementsByClassName("van-tabs__line");
              demo[0].style.left="-10px";
            })
          }
        });
    },
    onClick(name) {
      this.$nextTick(() => {
        var demo = document.getElementsByClassName("van-tabs__line");
        if(name == '0') {
          demo[0].style.left="-10px";
          this.task = this.tmp.filter(item => item.status==1||item.status==3||item.status==4||item.status==8 )
        }else{
          demo[0].style.left="0px";
          if(name == '1') this.task = this.tmp.filter(item => item.status==2||item.status==9 )
          if(name == '2') this.task = this.tmp.filter(item => item.status==5||item.status==6||item.status==7 )
        }
      })
    },
    question(){
      this.$dialog.alert({
        title: '进行中',
        message: '包含已领取的即将开始任务；部分无需领取的任务也将显示在【进行中】的任务列表中。',
        confirmButtonText:"我知道了",
        className:"question"
      }).then(() => {
        // on close
      });
    },
    numStr(num){
    let result = num.toString().indexOf(".");
      if (result != -1) {
        let str = num.toString().split(".")[1];
        if (str == "00") num = parseInt(num);
      }
      return num
  }
  },
  beforeRouteLeave(to, from, next) {
      from.meta.keepAlive = false;
      next();
  }
};
</script>

<style scoped lang="scss">
$color1: #ffffff;
$color2: #aaaaaa;
$color3: #888888;
$color4: #535353;
$color5: #ff8e00;
$color6: #dd2b1e;
$size24: 0.24rem;
$size32: 0.32rem;

.container {
  width: 100%;
  height: 100vh;
  overflow-y: scroll;
  .list {
    margin: 0.3rem;
    .posts-list {
      position: relative;
      padding: 0.3rem;
      margin-bottom: 0.3rem;
      background: $color1;
      border-radius: 0.16rem;
      span {
        position: absolute;
        right: 0.3rem;
        top: 9%;
        font-size: 0.2rem;
        text-align: center;
        color:#fff;
        // background: $color5;
        // background: url("../img/icon.png") center no-repeat;
        // background-size: contain;
        border-radius:0.08rem;
        padding: 0.1rem 0.26rem;
      }
      h1 {
        font-size: 0.3rem;
            width: 70%;
      }
      p {
        color: $color3;
        font-size: $size24;
        padding: 0.3rem 0;
        i {
          color: $color4;
          font-style: normal;
        }
      }
      h2 {
        padding: 0.12rem 0.2rem;
        width: fit-content;
        color: $color5;
        background: rgba(255, 142, 0, 0.05);
      }
      .button {
        display: block;
        font-size: $size32;
        text-align: center;
        margin-top: 0.3rem;
        padding: 0.28rem 0;
        color: $color6;
        background: rgba(252, 232, 230, 1);
        // background: linear-gradient(
        //   90deg,
        //   rgba(240, 86, 64, 1) 0%,
        //   rgba(221, 43, 30, 1) 100%
        // );
        border-radius: 0.16rem;
      }
    }
  }
  .no-data {
  text-align: center;
  margin-top: 1rem;
  color: #666;
}
  .color1{
    background: rgba(255, 142, 0, 0.6);
  }
  .color23{
    background: rgba(0, 176, 149, 1);
  }
  .color4{
    background: rgba(255, 142, 0,1);
  }
  .color5{
    background: rgba(247, 81, 81, 1);
  }
  .color6{
    background: rgba(0, 176, 149, 0.6);
  }
  .color7{
    background: rgba(204, 204, 204, 1);
  }
}
</style>
<style lang="scss">
.tabStyle {
  .van-icon{
  color: #999;
}
.van-tab{
font-weight: bold;
}
}
.question{
  .van-dialog__header,.van-dialog__footer>.van-button__text{
    font-size: 0.34rem;
  }
  .van-dialog__message{
    font-size: 0.28rem;
    padding: 0.3rem 0.42rem 0.4rem !important;
  }
}
</style>
